import { AdminService } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import type { VoiceConnectionOptions } from '../types';

export async function getVoiceConnectionOptions(): Promise<VoiceConnectionOptions> {
  logger.debug('[CXone SDK] Getting voice connection options from AdminService...');

  try {
    const adminService = AdminService.instance;
    const agentSettings = await adminService.getAgentSettings();

    logger.debug('[CXone SDK] Agent settings received:', agentSettings);

    const options: VoiceConnectionOptions = {
      webRTCType: agentSettings.webRTCType || '',
      webRTCWssUrls: agentSettings.webRTCWssUrls || [],
      webRTCServerDomain: agentSettings.webRTCServerDomain || '',
      webRTCIceUrls: agentSettings.webRTCIceUrls || [],
      webRTCDnis: agentSettings.webRTCDnis || '',
    };

    logger.debug('[CXone SDK] Voice connection options:', options);
    return options;
  } catch (error) {
    logger.error('[CXone SDK] Failed to get voice connection options:', error);
    throw error;
  }
}
